export class EmailSnippetsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEmailSnippets({ filterByRole = false, includeTemplate = true } = {}) {
    return this.#http.get('/email-snippets', { params: { filterByRole, includeTemplate } });
  }

  async getGeneratedSnippet({ snippetId, applicationId }) {
    return this.#http.get(`/email-snippets/${snippetId}/generate/application/${applicationId}`);
  }

  async getGeneratedSnippetForContact({ snippetId, contactId }) {
    return this.#http.get(`/email-snippets/${snippetId}/generate/contact/${contactId}`);
  }

  async createEmailSnippet({ ...body }) {
    return this.#http.post('/email-snippets', body);
  }

  async updateEmailSnippet({ id, ...body }) {
    return this.#http.put(`/email-snippets/${id}`, body);
  }

  async deleteEmailSnippet({ id }) {
    return this.#http.delete(`/email-snippets/${id}`);
  }

  async getEmailSnippetPreview({ snippetId }) {
    return this.#http.get(`/email-snippets/${snippetId}/preview`);
  }
}
